export default __webpack_public_path__ + "static/media/4_equipa.b0a6707a.svg";